import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import { GetTournamentQuery } from "generated/graphql";
dayjs.extend(isSameOrAfter);

const teamSizeMap = {
  TEAM_SOLO: 1,
  TEAM_DUOS: 2,
  TEAM_TRIOS: 3,
  TEAM_3v3: 3,
  TEAM_SQUAD: 4,
  TEAM_5v5: 5,
};

function TournamentRegistrations({
  tournamentData,
  tournamentDetailsMap,
}: {
  tournamentData?: GetTournamentQuery;
  tournamentDetailsMap: any;
}) {
  const teamType = tournamentDetailsMap["teamType"];
  // @ts-ignore
  const teamSize = teamSizeMap[teamType];

  const particpants = tournamentData?.tournament?.participants || [];

  return (
    <div className="tournament-reg-wrapper">
      <h2>Who's registered?</h2>
      <ul>
        {particpants.map((participant) => (
          <li key={participant.id}>
            <b title={participant.party.name}>{participant.party.nickname}</b>
            {teamSize > 1 && (
              <ul>
                {participant.party.party_relationships.map((member) => (
                  <li key={member.id}>
                    {member.partyByParticipant.name} (
                    {member.partyByParticipant.nickname})
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default TournamentRegistrations;
